module.exports = __webpack_public_path__ + "img/loading.c6ecfbce.svg";